







import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { parse as parseDate, format as formatDate } from "date-fns";

@Component({
	name: "el-date",
})
export default class ElDate extends Vue {
	@Prop({ default: () => `_id${Math.random() * 10000}` })
	id: string;

	@Prop()
	label: string;

	@Prop({ default: "dd/mm/aaaa" })
	placeholder: string;

	@Prop()
	value: Date;

	@Prop()
	validator: Function;

	@Prop({ default: false }) required: boolean;

	dateString: string = "";

	@Watch("value")
	updateDateString(value) {
		try {
			this.dateString = formatDate(value, "dd/MM/yyyy");
		} catch (error) {
			console.error(error);
		}
	}

	updateDate(value) {
		if (value && value.length === 10) {
			this.$emit("input", parseDate(value, "dd/MM/yyyy", new Date()));
		}
	}
}
